import { Button } from '@pata-app/ui-form';

import React, { useState } from 'react';

import generateQueryString from '../../../../../lib/utils/generateQueryString';
import { getEnv } from '../../../../../lib/utils/getEnv';
import SearchInputs from './components/searchInputs/searchInputs';
import { SearchBoxContainer } from './searchBox.styled';

const { VITE_WEB_BASE_URL } = getEnv();

const SearchBox = () => {
  const [searchState, setSearchState] = useState({
    searchTerm: null,
    searchTermType: null,
    locationType: null,
    location: null,
    lat: null,
    lng: null,
  });

  const handleInputChange = (field: string, value: any) => {
    if (field === 'searchTerm') {
      setSearchState({
        ...searchState,
        searchTerm: value.name,
        searchTermType: value.type,
      });
    }
    if (field === 'location') {
      setSearchState({
        ...searchState,
        location: value.name,
        locationType: value.locationType,
        lat: value.lat,
        lng: value.lng,
      });
    }
  };

  const handleSearch = () => {
    const formattedQueryStringObject = Object.keys(searchState).reduce(
      (updatedObject, key) => ({
        ...updatedObject,
        [key.toLowerCase()]: searchState[key as keyof typeof searchState],
      }),
      {},
    );

    const queryString = generateQueryString(formattedQueryStringObject);

    window.location.href = `${VITE_WEB_BASE_URL}/p/search${queryString}`;
  };

  return (
    <SearchBoxContainer>
      <SearchInputs
        searchTerm={searchState.searchTerm}
        location={searchState.location || (searchState.lat && 'Current Location')}
        onChange={handleInputChange}
      />
      <Button buttonType="primary" onClick={handleSearch}>
        Fetch!
      </Button>
    </SearchBoxContainer>
  );
};

export default SearchBox;
